import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function PdfViewer() {
  const { '*': filePath } = useParams();
  const navigate = useNavigate();

  const decoded = decodeURIComponent(filePath || '');
  // URL do PHP que serve o PDF com proteção
  const viewUrl = `/pdf.php?file=${encodeURIComponent(decoded)}`;
  const dlUrl   = `/pdf.php?file=${encodeURIComponent(decoded)}&dl=1`;
  // Título: pega o nome do arquivo sem extensão
  const titulo  = decoded.split('/').pop().replace('.pdf', '');

  useEffect(() => {
    document.title = titulo + ' — ROP';
    return () => { document.title = 'Revista Ordem Pública — ACORS'; };
  }, [titulo]);

  return (
    <div className="pdf-page">
      <div className="pdf-topbar">
        <div className="pdf-topbar-left">
          <button className="btn-voltar" onClick={() => navigate(-1)}>
            <svg viewBox="0 0 12 12"><polyline points="8,2 4,6 8,10"/></svg>
            Voltar
          </button>
          <span className="pdf-title">{titulo}</span>
        </div>
        <a className="btn-dl-white" href={dlUrl} download target="_blank" rel="noreferrer">
          <svg viewBox="0 0 12 12"><path d="M6 2 L6 8"/><path d="M3 6 L6 9 L9 6"/><path d="M2 11 L10 11"/></svg>
          Baixar PDF
        </a>
      </div>
      <iframe className="pdf-frame" src={viewUrl} title={titulo} />
    </div>
  );
}
